import { useTheme } from '../hooks/useTheme';
import { Theme } from '../state/theme';
import { DrawerHeader, DrawerHeaderViewProps } from './DrawerHeader';

export function DrawerHeaderWrapper(props: Omit<DrawerHeaderViewProps, 'isDarkTheme'>) {
  const { theme } = useTheme();

  return <DrawerHeader {...props} isDarkTheme={theme === Theme.DARK} />;
}
